import { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from './typography';
import Alert from './alert';
import { axiosInstance } from '../utils/axiosApi';

const ClinicCard = ({ clinic }) => (
    <div style={{
        border: '1px solid #e0e0e0',
        borderRadius: 8,
        padding: '16px',
        marginTop: 12,
        display: 'flex',
        gap: 16,
        alignItems: 'flex-start',
    }}>
        <div style={{ width: 120, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {clinic.logo_url && (
                <img
                    src={clinic.logo_url}
                    alt={`${clinic.full_name} logo`}
                    style={{ maxHeight: 48, maxWidth: 120, objectFit: 'contain' }}
                />
            )}
        </div>
        <div>
            <Typography variant="bodyTextSmallBold">{clinic.full_name}</Typography>
            {clinic.address && (
                <Typography variant="bodyTextSmall" style={{ whiteSpace: 'pre-line', marginTop: 4 }}>
                    {clinic.address}
                </Typography>
            )}
            {clinic.phone_number && (
                <Typography variant="bodyTextSmall" style={{ marginTop: 4 }}>
                    {clinic.phone_number}
                </Typography>
            )}
            {clinic.email && (
                <Typography variant="bodyTextSmall" style={{ marginTop: 4 }}>
                    {clinic.email}
                </Typography>
            )}
        </div>
    </div>
)

/**
 * Intro copy plus a searchable list of healthcare providers using Imunis.
 * Shared by the clinic-managed sign up page and the sharing invite landing page.
 */
const ClinicLookup = () => {
    const [clinics, setClinics] = useState([])
    const [search, setSearch] = useState('')
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        axiosInstance.get('/clinics/').then(response => {
            setClinics(response.data.data)
        }).catch(() => {
            setError('Unable to load healthcare providers. Please try again later.')
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    const filtered = clinics.filter(c =>
        c.full_name.toLowerCase().includes(search.toLowerCase())
    )

    return (
        <>
            <TextField
                label="Search healthcare providers"
                placeholder="Search by name"
                fullWidth
                margin="normal"
                value={search}
                onChange={e => setSearch(e.target.value)}
            />
            {error && <Alert severity="error">{error}</Alert>}
            {!loading && !error && filtered.length === 0 && (
                <Typography variant="bodyTextSmall">No providers found.</Typography>
            )}
            {filtered.map(clinic => (
                <ClinicCard key={clinic.uuid} clinic={clinic} />
            ))}
        </>
    )
}

export default ClinicLookup
